import Application from "../../Application";
import { IApplicantService } from "../../service/applicant/ApplicantService";
import { TApplicantsAppointment } from "../../model/applicant/ApplicantsAppointment";

export default class CreateApplicantsAppointmentInteractor {
  private application: Application;
  private applicantService: IApplicantService;

  constructor(application, applicantService) {
    this.application = application;
    this.applicantService = applicantService;
  }

  async execute(applicantAppointment: TApplicantsAppointment) {
    return this.applicantService.createApplicantsAppointment(
      applicantAppointment
    );
  }
}
